import { render, staticRenderFns } from "./HistoricClinics.vue?vue&type=template&id=1887ee40"
import script from "./HistoricClinics.vue?vue&type=script&lang=js"
export * from "./HistoricClinics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports